/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'svg-classlist-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <div>
    <App />
  </div>,
);

//For production need to un-comment this line to disabled console.log
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.get('debug') === 'true') {
  console.log('*****debug is on *******');
} else {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.log('*****debug is on *******');
  } else {
    console.log = function () {};
  }
}
